/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const RulerIcon = ({ width = 24, height = 24, hidden = false, title = 'Ruler' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m18.09082,4.02637l-2.11719-2.11719c-.84961-.84961-2.3335-.84961-3.18213,0L1.90967,12.79785c-.87695.87695-.87744,2.30469,0,3.18262l2.11719,2.11719c.4248.4248.99023.65918,1.59131.65918s1.16602-.23438,1.59082-.65918l10.88281-10.88965c.87646-.87793.87598-2.30469-.00098-3.18164Zm-1.06006,2.12109l-10.88232,10.88965h-.00049c-.28271.2832-.77783.2832-1.06055,0l-2.1167-2.11719c-.29297-.29297-.29297-.76855-.00049-1.06152l1.00995-1.0105,1.76447,1.7644c.14648.14648.33838.21973.53027.21973s.38379-.07324.53027-.21973c.29297-.29297.29297-.76758,0-1.06055l-1.76477-1.76477,1.54059-1.54138,1.05817,1.05811c.14648.14648.33838.21973.53027.21973s.38379-.07324.53027-.21973c.29297-.29297.29297-.76758,0-1.06055l-1.05847-1.05847,1.54028-1.54114,1.76624,1.7666c.14648.14648.33838.21973.53027.21973s.38379-.07324.53027-.21973c.29297-.29297.29297-.76758,0-1.06055l-1.76654-1.76697,1.5401-1.54102,1.05994,1.05994c.14648.14648.33838.21973.53027.21973s.38379-.07324.53027-.21973c.29297-.29297.29297-.76758,0-1.06055l-1.06024-1.0603,1.01044-1.01099c.14111-.1416.32959-.21973.52979-.21973.20068,0,.38916.07812.53076.21973l2.11719,2.11719c.29248.29199.29248.76855.00049,1.06055Z"
      fill="currentColor"
      stroke-width="0"
    />
  </svg>`;
};
